module.exports = __webpack_public_path__ + "static/media/velora-login-background.d5d97736.svg";